var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.51845 0.107995L19.3968 9.00438C19.9252 9.26732 20.1487 9.92618 19.896 10.476C19.7914 10.7033 19.6153 10.8866 19.3968 10.9954L1.51845 19.8918C0.990025 20.1547 0.356784 19.9222 0.104061 19.3724C-0.00575963 19.1334 -0.0293356 18.8614 0.0376371 18.6059L1.82583 11.7838C1.87062 11.6129 2.00929 11.4864 2.17801 11.4625L10.8414 10.2381C10.916 10.227 10.9779 10.176 11.0065 10.1063L11.0214 10.0509C11.0356 9.94745 10.9784 9.85054 10.8887 9.81411L10.8414 9.80119L2.18815 8.57683C2.01945 8.55296 1.88081 8.42648 1.83602 8.25559L0.0376371 1.39384C-0.116483 0.80587 0.216687 0.199238 0.781793 0.0388836C1.02736 -0.0307982 1.28882 -0.00626834 1.51845 0.107995Z",
    fill: "#1E7C88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.d287ca814a1b07195126ed61032a9b41.svg";
export { ForwardRef as ReactComponent };